export const HOTKEYS = {
  focusCommentComposer: 'r',
}
